import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@shared/utils";

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  /** Size of the button container in pixels */
  size?: number;
  /** Additional classes */
  className?: string;
}

/**
 * Icon-only button atom.
 * Renders a transparent button wrapping an icon.
 */
export function IconButton({
  children,
  size = 24,
  className,
  ...props
}: IconButtonProps) {
  return (
    <button
      className={cn(
        "inline-flex items-center justify-center bg-transparent border-none cursor-pointer transition-opacity hover:opacity-80",
        className,
      )}
      style={{ width: size, height: size }}
      {...props}
    >
      {children}
    </button>
  );
}
